module.exports = __webpack_public_path__ + "img/reset_choosed.a7c7aab5.png";